<template>
    <AuthFormAlt 
        auth-type="login"
        :loading="loading"
        :error="error"
        @form-submit="handleLogin"
    />
</template>

<script>
import AuthFormAlt from "@/components/auth/AuthForm.vue";

export default {
    name: "LoginPage",

    components: {
        AuthFormAlt,
    },

    data() {
        return {
            error: {
                show: false,
                value: "",
            },
            loading: false,
        };
    },

    computed: {
        isAuthenticated() {
            return this.$store.getters["auth/isAuthenticated"];
        },
    },

    methods: {
        async handleLogin(payload) {
            try {
                this.error.show = false;
                this.error.value = "";
                this.loading = true;

                const res = await this.$store.dispatch("auth/login", payload);

                this.$store.dispatch("auth/setAuthStatus", true);
                this.$store.dispatch("auth/setLastChecked", Date.now());
                this.$toast.success("Login successful");

                const ongoingSession = res.redirect && res.redirect_type === "token_valid";
                const redirectPath = this.$route.query.redirect;

                this.loading = false;

                if (ongoingSession && redirectPath) {
                    return this.$router.push(`${redirectPath}`);
                } else {
                    return this.$router.push({ name: "reports", query: { type: "clients", range: "1_year" }});
                }
            } catch (error) {                
                const errMsg = error?.response?.data?.message || error?.message;                                
                this.error.value = errMsg;
                this.error.show = true;
                this.$toast.error(errMsg);
                this.loading = false;
            }
        },
    },
};
</script>